import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LandTitleDto } from '@cradua/data';

@Component({
  selector: 'cradua-incidentassetpopup-list',
  templateUrl: './incidentassetpopup-list.component.html',
  styleUrls: ['./incidentassetpopup-list.component.scss']
})
export class IncidentassetpopupListComponent implements OnInit {

  @Input() landTitles: LandTitleDto[];
  @Output() emitLandTitle = new EventEmitter<any>();
  @Output() taskEmit = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {}

  onTaskEmit() {

  }

  onView(value) {
    this.emitLandTitle.emit(value);
  }

}
